var $2ccc589e2f51824d$exports = {};
$2ccc589e2f51824d$exports = {
  "decrease": function decrease(args) {
    return "\u0417\u043C\u0435\u043D\u0448\u0438\u0442\u0438 ".concat(args.fieldLabel);
  },
  "increase": function increase(args) {
    return "\u0417\u0431\u0456\u043B\u044C\u0448\u0438\u0442\u0438 ".concat(args.fieldLabel);
  },
  "numberField": "\u041F\u043E\u043B\u0435 \u043D\u043E\u043C\u0435\u0440\u0430"
};
export { $2ccc589e2f51824d$exports as default };